// Localizzazione del tema — issue #641 (14/09/2026).
//
// Con la redirezione automatica Markets SPENTA (decisione del committente
// del 14/09/2026: il WAF Shopify in «allerta alta» rimbalzava Googlebot con
// 302), questo file governa due elementi:
//   1. <banner-redirect>: il popup del SELETTORE MANUALE (paese + lingua),
//      che si apre al clic sui trigger `.select-country-trigger` (footer
//      «Country», header, mobile) come prima;
//   2. <market-suggest-bar>: la BARRA DI RACCOMANDAZIONE del mercato, non
//      bloccante, in alto subito sotto l'header (decisione del committente
//      del 14/09 ~19:20 CEST, criterio Baymard Institute: al posto della
//      scheda in basso a destra delle revisioni precedenti). Appena il
//      documento e' interattivo (script `defer` → DOMContentLoaded, con al
//      massimo ~400 ms di attesa per un momento di idle) si chiama l'endpoint
//      NATIVO di Shopify
//      `{root}browsing_context_suggestions.json?country[enabled]=true
//      &language[enabled]=true` (nessun servizio terzo di geolocalizzazione)
//      e, se il paese rilevato appartiene a un mercato diverso da quello
//      della pagina, la barra compare gia' valorizzata appena arriva la
//      risposta (e SOLO quando il banner cookie OneTrust non e' visibile):
//      «Vai al sito {paese}» = submit del form nativo `localization` con il
//      paese rilevato preselezionato (Shopify scrive il cookie e porta
//      l'utente nella sottocartella del mercato); «Resta qui» = scelta
//      memorizzata 30 giorni (localStorage + cookie tecnico
//      `vietti_market_choice`, categoria «necessari»); X = niente
//      suggerimenti per la sessione.
//
// Cosa NON fa, per regola: MAI un redirect automatico (nemmeno via
// JavaScript: Google conta anche quelli); niente in design mode; nessun
// overlay, nessun blocco dello scroll. La barra e' `position: fixed; top: 0`
// e viene spostata sotto l'header con `transform: translateY(offset)`, dove
// l'offset e' il bordo inferiore reale di #shopify-section-header (letto e
// aggiornato allo scroll, cosi' segue l'header sticky che si nasconde e
// ricompare): le trasformazioni sono composited e non entrano nel CLS; la
// barra non e' candidata LCP. Dal #780 (01/10/2026), da 768 px in su, la
// barra visibile SPINGE in basso il contenuto di <main> della sua altezza
// (vedi setPush): prima lo copriva, e su desktop copriva titolo e brand della
// PDP. Su mobile resta sovrapposta alla galleria (nessun CLS). I crawler che
// eseguono JS possono vederla: non cambia URL, contenuto ne' link.
//
// Tempi: la prima versione (PR #642) aspettava `load` + 1,5 s: su iPhone
// reale il suggerimento compariva con molto ritardo (collaudo del
// committente del 14/09 ~18:00 CEST) perche' `load` attende immagini e
// script terzi. Ora: readyState interactive → requestIdleCallback (timeout
// 400 ms; senza rIC, es. Safari, setTimeout 300 ms) → fetch → barra alla
// risposta — salvo il banner cookie OneTrust ancora visibile: in quel caso
// la barra esce appena il banner scompare (vedi showAfterConsent: mai
// insieme al banner; dopo 60 s col banner aperto, niente suggerimento in
// questa pagina). Diagnostica: performance.mark
// `vietti:market-suggest:request`, `:ready` (risposta valutata) e `:shown`
// (barra a video) — leggibili da DevTools, nessun log.
//
// La mappa paese -> [mercato, valuta] arriva dal Liquid dello snippet
// bannerRedirect (localization.available_countries): niente elenchi
// hardcoded qui.
//
// Misura (#957, decisione del committente del 01/10/2026 sera): evento
// `market_suggest` con `market_suggest_action` = shown | go | stay | close,
// mercato di partenza e di destinazione. Parte SOLO con il consenso
// statistico: `Shopify.customerPrivacy.analyticsProcessingAllowed()` (la
// stessa API dei gate di consenso del tema, alimentata da OneTrust).
// FAIL-CLOSED: senza API o senza consenso non parte nulla; con decisione in
// sospeso resta in coda (max 10) finche' `visitorConsentCollected` non porta
// `analyticsAllowed`. Destinazioni: `window.dataLayer`, GA4 tramite il
// Google tag gia' presente in pagina (`gtag('event', …, {send_to: G-…})`,
// solo se `window.gtag` esiste) e `Shopify.analytics.publish` (per un
// eventuale custom pixel Customer Events). Il `go` si
// registra sulla PAGINA DI ARRIVO (sessionStorage, con `market_landed`): il
// submit nativo cambia pagina e un invio fatto prima andrebbe perso.
// Nessun cookie nuovo, nessun dato personale.
(function () {
  const CHOICE_KEY = 'vietti:market-choice';        // localStorage (30 giorni)
  const CHOICE_COOKIE = 'vietti_market_choice';     // cookie tecnico gemello
  const DISMISS_KEY = 'vietti:market-suggest-dismissed'; // sessionStorage (chiusura con X)
  const CHOICE_MAX_AGE_DAYS = 30;
  const CHOICE_MAX_AGE_MS = CHOICE_MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
  const IDLE_TIMEOUT_MS = 400;     // attesa massima di un momento di idle dopo l'interattivita'
  const FALLBACK_DELAY_MS = 300;   // browser senza requestIdleCallback (Safari)
  const CONSENT_POLL_MS = 500;         // controllo di sicurezza sul banner cookie (oltre a MutationObserver ed eventi)
  const CONSENT_SETTLE_MS = 800;       // «banner non visibile» senza cookie di chiusura deve reggere cosi' a lungo
  const NO_BANNER_GRACE_MS = 8000;     // OneTrust presente ma mai inizializzato (script bloccato): si mostra comunque
  const CONSENT_WAIT_MAX_MS = 60000;   // banner ancora aperto dopo 60 s: niente suggerimento in questa pagina
  const FOLLOW_FRAMES = 20;            // frame in cui la barra segue l'animazione dell'header sticky (~0,3 s)
  const PUSH_MEDIA = '(min-width: 768px)'; // larghezze in cui la barra spinge il contenuto (#780)
  const MEASURE_EVENT = 'market_suggest';      // evento di misura (#957)
  const PENDING_GO_KEY = 'vietti:market-suggest:go'; // sessionStorage: «go» da registrare sulla pagina di arrivo
  const PENDING_GO_MAX_MS = 10 * 60 * 1000;    // un «go» piu' vecchio di 10 minuti non si registra
  const MEASURE_QUEUE_MAX = 10;                // eventi in attesa della decisione sul consenso
  const GA4_WAIT_MS = 500;                     // attesa del Google tag della pagina (si carica dopo il consenso)
  const GA4_WAIT_TRIES = 20;                   // 20 x 500 ms = 10 s al massimo

  function safeStorage(kind, fn) {
    try {
      const store = kind === 'session' ? window.sessionStorage : window.localStorage;
      return fn(store);
    } catch (e) {
      return null;
    }
  }

  function mark(name) {
    try {
      if (window.performance && performance.mark) performance.mark(name);
    } catch (e) { /* diagnostica facoltativa */ }
  }

  function readCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, maxAgeSeconds) {
    let cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAgeSeconds + '; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function fill(template, values) {
    let out = template || '';
    Object.keys(values).forEach((key) => {
      out = out.split('[' + key + ']').join(values[key]);
    });
    return out;
  }

  // ── Misura con consenso statistico (#957) ──────────────────────────────
  const measureQueue = [];
  let privacyWatched = false;

  function privacyApi() {
    const api = window.Shopify && window.Shopify.customerPrivacy;
    return api && typeof api.analyticsProcessingAllowed === 'function' ? api : null;
  }

  function analyticsAllowed() {
    const api = privacyApi();
    if (!api) return false; // fail-closed: senza API nessun evento
    try {
      return api.analyticsProcessingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  // ID della proprieta' GA4 gia' configurata nel Google tag della pagina
  // (caricato dall'app Google & YouTube tramite il pixel manager di Shopify,
  // verificato il 01/10/2026: G-L18JTNHQX8): nessun ID scritto nel tema.
  function ga4Id() {
    try {
      return Object.keys(window.google_tag_manager || {}).find((k) => /^G-[A-Z0-9]+$/.test(k)) || '';
    } catch (e) {
      return '';
    }
  }

  // GA4 diretto, solo verso la proprieta' GA4 (send_to): i tag Ads (GT-)
  // della stessa pagina non ricevono l'evento. Il Google tag si carica DOPO
  // il consenso, quasi insieme alla barra (collaudo 01/10: 7 «shown» su 8
  // persi senza attesa): se non e' ancora pronto si riprova ogni 500 ms per
  // al massimo 10 s, poi si rinuncia (resta il dataLayer).
  function sendGa4(payload, attempt) {
    try {
      const id = ga4Id();
      if (id && typeof window.gtag === 'function') {
        window.gtag('event', MEASURE_EVENT, Object.assign({ send_to: id }, payload));
        return;
      }
    } catch (e) { return; /* misura facoltativa: mai un errore in pagina */ }
    if (attempt < GA4_WAIT_TRIES) window.setTimeout(() => sendGa4(payload, attempt + 1), GA4_WAIT_MS);
  }

  function sendMeasure(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: MEASURE_EVENT }, payload));
    sendGa4(payload, 0);
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(MEASURE_EVENT, payload);
      }
    } catch (e) { /* idem */ }
  }

  function flushMeasures(granted) {
    if (!granted && !analyticsAllowed()) return;
    while (measureQueue.length) sendMeasure(measureQueue.shift());
  }

  function watchPrivacy() {
    if (privacyWatched) return;
    privacyWatched = true;
    // Consenso dato dal banner nella stessa pagina: la coda parte allora.
    document.addEventListener('visitorConsentCollected', (event) => {
      const detail = event && event.detail;
      if (detail && detail.analyticsAllowed) flushMeasures(true);
    });
    if (!privacyApi() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) flushMeasures(false);
        });
      } catch (e) { /* API non disponibile: fail-closed */ }
    }
  }

  function track(payload) {
    watchPrivacy();
    if (analyticsAllowed()) {
      flushMeasures(true);
      sendMeasure(payload);
      return;
    }
    if (measureQueue.length < MEASURE_QUEUE_MAX) measureQueue.push(payload);
  }

  // ── Coda delle interruzioni (#1339) ────────────────────────────────────
  // Con il setting `enable_interruption_queue` acceso, assets/interruzioni.js
  // (caricato prima di questo file) espone window.viettiInterruzioni: la
  // barra le dichiara il proprio stato (pending → shown/hidden/none) e le
  // chiede il turno prima di mostrarsi (attende un popup Klaviyo gia'
  // aperto). Setting spento = oggetto assente = comportamento precedente.
  function queue() {
    const q = window.viettiInterruzioni;
    return q && typeof q.market === 'function' && typeof q.chiedi === 'function' ? q : null;
  }

  function queueState(state) {
    const q = queue();
    if (q) {
      try { q.market(state); } catch (e) { /* la coda non deve mai fermare la barra */ }
    }
  }

  // Evento del browser generato dall'utente (clic, tasto). `isTrusted` e'
  // false solo per eventi creati da script (element.click(), dispatchEvent).
  function isUserEvent(event) {
    return Boolean(event) && event.isTrusted !== false;
  }

  function pageType() {
    try {
      const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      return (meta && meta.page && meta.page.pageType) || '';
    } catch (e) {
      return '';
    }
  }

  // ── Barra di raccomandazione (in alto, sotto l'header) ─────────────────
  class MarketSuggestBar extends HTMLElement {
    connectedCallback() {
      this.textNode = this.querySelector('.market-suggest-bar__text');
      this.goButton = this.querySelector('.market-suggest-bar__go');
      this.goLabel = this.goButton ? this.goButton.querySelector('span') || this.goButton : null;
      this.countryInput = this.querySelector('[data-market-suggest-country]');
      this.stayButton = this.querySelector('.market-suggest-bar__stay');
      this.closeButton = this.querySelector('.market-suggest-bar__close');
      this.lastOffset = null;
      this.frame = null;
      this.followFrames = 0;
      this.onViewportChange = () => this.scheduleUpdate(FOLLOW_FRAMES);
      // Resize: oltre all'offset, la spinta (si accende/spegne attraversando i 768 px).
      this.onResize = () => {
        this.onViewportChange();
        if (this.classList.contains('visible')) this.setPush(this.offsetHeight);
      };
    }

    // Pronta per il submit nativo: paese rilevato nel campo nascosto, testi
    // valorizzati (#957: paese e valuta di destinazione; il tasto dice
    // «Shop in USD» se la valuta cambia, altrimenti «Go to the {paese} site»).
    // Il testo della regione live si scrive solo in show(), a barra visibile:
    // scritto da nascosta, il lettore di schermo non lo annunciava.
    prepare(suggestion) {
      if (!this.countryInput || !this.goButton) return false;
      this.countryInput.value = suggestion.iso;
      const values = { country: suggestion.country, currency: suggestion.currency };
      this.pendingText = fill(this.dataset.text, values);
      const sameCurrency = !suggestion.currency || suggestion.currency === suggestion.currentCurrency;
      const goTemplate = !sameCurrency && this.dataset.goCurrency ? this.dataset.goCurrency : this.dataset.go;
      if (this.goLabel) this.goLabel.textContent = fill(goTemplate, values);
      return true;
    }

    headerElement() {
      return document.getElementById('shopify-section-header') ||
        document.getElementById('shopify-section-header-boutique') ||
        document.querySelector('.header-wrapper');
    }

    // Offset = bordo inferiore reale dell'header (annunci inclusi quando la
    // pagina e' in cima; l'header sticky che si nasconde porta l'offset a 0).
    updateOffset() {
      const header = this.headerElement();
      let offset = 0;
      if (header) {
        const rect = header.getBoundingClientRect();
        offset = Math.max(0, Math.round(rect.bottom));
        if (offset > window.innerHeight) offset = 0;
      }
      if (offset !== this.lastOffset) {
        this.lastOffset = offset;
        this.style.setProperty('--msb-offset', offset + 'px');
        return true;
      }
      return false;
    }

    scheduleUpdate(follow) {
      this.followFrames = Math.max(this.followFrames, follow || 0);
      if (this.frame) return;
      const tick = () => {
        this.frame = null;
        const changed = this.updateOffset();
        // Dopo uno scroll l'header sticky anima per ~150 ms: si segue per qualche frame.
        if (this.followFrames > 0 || changed) {
          this.followFrames = Math.max(0, this.followFrames - 1);
          if (this.followFrames > 0) this.frame = window.requestAnimationFrame(tick);
        }
      };
      this.frame = window.requestAnimationFrame(tick);
    }

    // Spinta del contenuto (#780, 01/10/2026): la barra fissa copriva titolo e
    // brand della PDP su desktop (prova del committente da /en-hk). Finche' e'
    // visibile, <main> riceve un padding-top pari all'altezza reale della barra
    // (--msb-push su <html>, classe .market-suggest-pushed; CSS nello snippet,
    // che sposta anche il `top` della colonna fissa della PDP). Se la pagina e'
    // gia' scrollata, lo scroll viene compensato nello stesso frame: il
    // contenuto resta fermo sotto gli occhi dell'utente.
    // Solo da 768 px in su: sotto, la barra sta sopra la galleria (titolo e
    // prezzo sono sotto le foto, mai coperti) e spingere la pagina costerebbe
    // ~0,09 di CLS mobile (collaudo #780 su anteprima, 01/10/2026).
    pushWanted() {
      return !window.matchMedia || window.matchMedia(PUSH_MEDIA).matches;
    }

    setPush(height) {
      const root = document.documentElement;
      const next = this.pushWanted() ? Math.max(0, Math.round(height || 0)) : 0;
      const prev = this.push || 0;
      if (next === prev) return;
      const scrolled = window.scrollY > 0;
      this.push = next;
      if (next > 0) {
        root.style.setProperty('--msb-push', next + 'px');
        root.classList.add('market-suggest-pushed');
      } else {
        root.classList.remove('market-suggest-pushed');
        root.style.removeProperty('--msb-push');
      }
      if (scrolled) window.scrollBy(0, next - prev);
    }

    show() {
      if (this.classList.contains('visible')) return;
      this.updateOffset();
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.classList.add('market-suggest-bar--animate');
      this.setPush(this.offsetHeight);
      if (window.ResizeObserver && !this.resizeObserver) {
        // Il testo va a capo su mobile o al resize: la spinta segue l'altezza vera.
        this.resizeObserver = new ResizeObserver(() => {
          if (this.classList.contains('visible')) this.setPush(this.offsetHeight);
        });
      }
      if (this.resizeObserver) this.resizeObserver.observe(this);
      // Un frame con l'offset gia' applicato, poi la classe: la transizione
      // scorre da sotto l'header alla posizione finale.
      window.requestAnimationFrame(() => {
        this.classList.add('visible');
        if (this.textNode && this.pendingText) this.textNode.textContent = this.pendingText;
        mark('vietti:market-suggest:shown');
      });
    }

    isVisible() {
      return this.classList.contains('visible');
    }

    hide() {
      // Chi chiude da tastiera («Resta qui»/X) non perde il focus nel vuoto:
      // passa a <main> (tabindex="-1" nel layout), da dove riprende il Tab.
      const hadFocus = this.contains(document.activeElement);
      this.classList.remove('visible');
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.setPush(0);
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onResize);
      if (this.frame) { window.cancelAnimationFrame(this.frame); this.frame = null; }
      if (hadFocus) {
        const main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
      }
    }
  }

  // ── Popup del selettore manuale + regia della raccomandazione ──────────
  class BannerRedirect extends HTMLElement {
    constructor() {
      super();
      this.currentMarket = this.dataset.currentMarket || '';
      this.currentCountry = (this.dataset.currentCountry || '').toUpperCase();
      this.currentCurrency = (this.dataset.currentCurrency || '').toUpperCase();
      this.suggestEnabled = this.dataset.suggestEnabled === 'true';
      this.suggestion = null;
      this.suggestionRequested = false;
    }

    connectedCallback() {
      this.closeButton = this.querySelector('.banner-redirect__close');
      this.countrySelect = this.querySelector('#select-country');
      this.languageSelect = this.querySelector('#language-switcher');
      this.form = this.querySelector('form');
      this.marketMap = this.readMarketMap();
      this.bar = document.querySelector('market-suggest-bar');

      this.bindEvents();
      this.trackPendingGo();

      if (this.suggestEnabled && this.bar && !this.isDesignMode() && this.canSuggest()) {
        queueState('pending');
        this.scheduleSuggestion();
      }
    }

    // ── Eventi ────────────────────────────────────────────────────────────
    bindEvents() {
      const triggers = document.querySelectorAll('.select-country-trigger');
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.open());
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      if (this.bar) {
        const stay = this.bar.querySelector('.market-suggest-bar__stay');
        const dismiss = this.bar.querySelector('.market-suggest-bar__close');
        const goForm = this.bar.querySelector('form');
        if (stay) stay.addEventListener('click', (event) => this.stayHere(event));
        if (dismiss) dismiss.addEventListener('click', (event) => this.dismissSuggestion(event));
        // «Go»: la misura parte sulla pagina di arrivo (vedi trackPendingGo).
        if (goForm) goForm.addEventListener('submit', () => this.rememberPendingGo());
      }

      // Ogni scelta esplicita di paese/lingua (popup, barra o altri form
      // `localization` del tema) vale come scelta dell'utente: per 30 giorni
      // nessuna raccomandazione. Il submit resta nativo: nessun redirect JS.
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form && form.getAttribute && /\/localization(\?|$)/.test(form.getAttribute('action') || '')) {
          this.rememberChoice('chosen', (form.querySelector('[name="country_code"]') || {}).value || '');
        }
      }, true);

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.classList.contains('visible')) { this.close(); return; }
        // Esc dentro la barra = X (#957, OP-2): stessa memoria di sessione.
        if (this.bar && this.bar.isVisible && this.bar.isVisible() && this.bar.contains(document.activeElement)) {
          this.dismissSuggestion(event);
        }
      });
    }

    open() {
      this.classList.add('visible');
    }

    close() {
      this.classList.remove('visible');
    }

    // «Resta qui», X ed Esc agiscono SOLO a barra visibile (ordine della regia
    // del 19/10/2026): la barra nascosta resta nel DOM (visibility: hidden) con
    // i listener attivi, e i clic di programmi sulla X invisibile gonfiavano i
    // «close» in GA4 (14–15/10: 1.111 contro 905 «shown», ~6 per utente).
    // Un clic generato da codice (isTrusted false) chiude come quello
    // dell'utente ma non si misura.
    barVisible() {
      return Boolean(this.bar && this.bar.isVisible && this.bar.isVisible());
    }

    stayHere(event) {
      if (!this.barVisible()) return;
      this.rememberChoice('stay', this.currentCountry);
      this.bar.hide();
      if (isUserEvent(event)) this.trackSuggestion('stay');
      queueState('hidden');
    }

    dismissSuggestion(event) {
      // Chiusura con la X (o Esc): niente piu' suggerimenti per questa sessione.
      if (!this.barVisible()) return;
      safeStorage('session', (s) => s.setItem(DISMISS_KEY, '1'));
      this.bar.hide();
      if (isUserEvent(event)) this.trackSuggestion('close');
      queueState('hidden');
    }

    // ── Misura (#957) ─────────────────────────────────────────────────────
    measurePayload(action) {
      const s = this.suggestion || {};
      return {
        market_suggest_action: action,
        market_from: this.currentMarket,
        market_to: s.market || '',
        country_detected: s.iso || '',
        currency_from: this.currentCurrency,
        currency_to: s.currency || '',
        page_type: pageType(),
      };
    }

    trackSuggestion(action) {
      if (!this.suggestion) return;
      track(this.measurePayload(action));
    }

    rememberPendingGo() {
      if (!this.suggestion) return;
      const payload = Object.assign(this.measurePayload('go'), { ts: Date.now() });
      safeStorage('session', (s) => s.setItem(PENDING_GO_KEY, JSON.stringify(payload)));
    }

    // Pagina di arrivo dopo «Go»: si registra una volta sola, con il mercato
    // effettivamente raggiunto (`market_landed`: verifica che il submit
    // nativo abbia portato al mercato proposto).
    trackPendingGo() {
      const raw = safeStorage('session', (s) => s.getItem(PENDING_GO_KEY));
      if (!raw) return;
      safeStorage('session', (s) => s.removeItem(PENDING_GO_KEY));
      try {
        const payload = JSON.parse(raw);
        if (!payload || !payload.ts || Date.now() - payload.ts > PENDING_GO_MAX_MS) return;
        delete payload.ts;
        payload.market_landed = this.currentMarket;
        track(payload);
      } catch (e) { /* voce illeggibile: nessun evento */ }
    }

    // ── Stato e memoria ───────────────────────────────────────────────────
    isDesignMode() {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }

    readMarketMap() {
      const node = this.querySelector('script[data-banner-redirect-markets]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent) || {};
      } catch (e) {
        return {};
      }
    }

    hasRecentChoice() {
      if (readCookie(CHOICE_COOKIE)) return true;
      const raw = safeStorage('local', (s) => s.getItem(CHOICE_KEY));
      if (!raw) return false;
      try {
        const choice = JSON.parse(raw);
        return Boolean(choice && choice.ts && Date.now() - choice.ts < CHOICE_MAX_AGE_MS);
      } catch (e) {
        return false;
      }
    }

    rememberChoice(kind, country) {
      const payload = JSON.stringify({ kind: kind, country: country || '', market: this.currentMarket, ts: Date.now() });
      safeStorage('local', (s) => s.setItem(CHOICE_KEY, payload));
      writeCookie(CHOICE_COOKIE, kind, CHOICE_MAX_AGE_DAYS * 24 * 60 * 60);
    }

    canSuggest() {
      if (!this.currentMarket || !this.form || !this.countrySelect) return false;
      if (this.hasRecentChoice()) return false;
      if (safeStorage('session', (s) => s.getItem(DISMISS_KEY))) return false;
      if (!window.fetch) return false;
      return true;
    }

    // ── Raccomandazione ───────────────────────────────────────────────────
    // Parte appena il documento e' interattivo (lo script e' `defer`: quando
    // gira, il parsing e' finito e DOMContentLoaded sta per scattare), NON
    // al `load`: su mobile `load` arriva molto dopo (immagini, script terzi).
    // Si concede al browser al massimo IDLE_TIMEOUT_MS per un momento di
    // idle, poi la chiamata parte comunque; la barra appare alla risposta.
    scheduleSuggestion() {
      const start = () => this.requestSuggestion();
      const run = () => {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(start, { timeout: IDLE_TIMEOUT_MS });
        } else {
          window.setTimeout(start, FALLBACK_DELAY_MS);
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
      } else {
        run();
      }
    }

    endpointUrl() {
      let root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (!root.endsWith('/')) root += '/';
      return root + 'browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true';
    }

    requestSuggestion() {
      if (this.suggestionRequested) return;
      this.suggestionRequested = true;
      mark('vietti:market-suggest:request');
      // Shopify localizza il nome del paese con l'Accept-Language della
      // richiesta (verificato il 14/09: «United States» vs «Stati Uniti»):
      // si chiede nella lingua della pagina, cosi' il testo resta coerente.
      const headers = { Accept: 'application/json' };
      if (this.dataset.currentLanguage) headers['Accept-Language'] = this.dataset.currentLanguage;
      fetch(this.endpointUrl(), { credentials: 'same-origin', headers: headers })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => { if (!this.handleSuggestion(data)) queueState('none'); })
        .catch(() => { queueState('none'); /* rete o formato inatteso: nessuna barra, nessun errore in console */ });
    }

    // true = barra in arrivo (dopo il consenso); false = nulla da proporre.
    handleSuggestion(data) {
      if (!data || !data.detected_values || !data.detected_values.country) return false;
      const detected = data.detected_values.country;
      const iso = String(detected.handle || '').toUpperCase();
      const countryName = detected.name || data.detected_values.country_name || iso;
      if (!iso || iso === this.currentCountry) return false;

      const entry = this.marketMap[iso];
      if (!entry) return false; // paese non servito da nessun mercato: nulla da proporre
      const targetMarket = entry[0];
      const targetCurrency = entry[1] || '';
      if (!targetMarket || targetMarket === this.currentMarket) return false;

      // Nessuna opzione corrispondente nel form nativo = nulla da inviare.
      const option = Array.from(this.countrySelect.options).find((o) => o.value.toUpperCase() === iso);
      if (!option) return false;
      if (this.classList.contains('visible')) return false; // l'utente sta gia' usando il selettore manuale

      this.suggestion = { iso: option.value, market: targetMarket, currency: targetCurrency, country: countryName, currentCurrency: this.currentCurrency };
      if (!this.bar || !this.bar.prepare(this.suggestion)) return false;
      // Anche il selettore manuale parte dal paese rilevato, se l'utente lo apre.
      this.countrySelect.value = option.value;
      mark('vietti:market-suggest:ready');
      const showBar = () => {
        if (this.hasRecentChoice() || safeStorage('session', (s) => s.getItem(DISMISS_KEY))) { queueState('none'); return; }
        this.bar.show();
        this.trackSuggestion('shown');
        queueState('shown');
      };
      this.showAfterConsent(() => {
        // #1339: con la coda accesa la barra chiede il turno (un popup
        // Klaviyo gia' aperto da solo passa prima); senza coda, subito.
        const q = queue();
        if (!q) { showBar(); return; }
        try { q.chiedi(showBar); } catch (e) { showBar(); }
      }, () => queueState('none'));
      return true;
    }

    // ── Convivenza col banner cookie (OneTrust, app embed) ────────────────
    // Il banner OneTrust si ancora in basso con z-index massimo e copriva il
    // tasto «Conferma» della vecchia scheda (collaudo del committente 14/09
    // ~18:10 CEST). La barra in alto non lo tocca fisicamente, ma la regola
    // resta per ordine del committente: il suggerimento compare SOLO quando
    // il banner `#onetrust-banner-sdk` NON e' visibile a video (una richiesta
    // alla volta: prima il consenso, poi il suggerimento).
    //   - banner assente (consenso gia' dato: cookie `OptanonAlertBoxClosed`;
    //     oppure mercati/regioni senza banner, con OneTrust inizializzato)
    //     → subito;
    //   - banner visibile → si aspetta che scompaia: MutationObserver sul
    //     documento (inserimento del banner, cambio di style/class alla
    //     chiusura), eventi OneTrust `OneTrustGroupsUpdated` e
    //     `consent.onetrust`, callback `OptanonWrapper` (incatenata a quella
    //     eventuale del sito e ripristinata alla fine) e un controllo di
    //     sicurezza ogni 500 ms; alla chiusura la barra esce subito;
    //   - OneTrust presente nella pagina ma mai inizializzato entro 8 s
    //     (script bloccato) e nessun banner → si mostra comunque;
    //   - dopo 60 s col banner ancora aperto si rinuncia: NIENTE barra in
    //     questa pagina (riparte alla pagina successiva).
    // Nessuna API OneTrust e' richiesta: si osserva il DOM; il cookie
    // `OptanonAlertBoxClosed` (scritto da OneTrust alla chiusura) e' solo la
    // via rapida. Senza cookie, «banner non visibile» deve reggere per
    // CONSENT_SETTLE_MS prima di mostrare: evita la finestra in cui OneTrust
    // ha gia' inserito il proprio markup ma non ha ancora deciso se mostrare
    // il banner.
    oneTrustOnPage() {
      return Boolean(window.OneTrust || window.Optanon || document.getElementById('onetrust-consent-sdk') ||
        document.querySelector('script[src*="cookielaw.org"], script[src*="onetrust"]'));
    }

    oneTrustReady() {
      if (readCookie('OptanonAlertBoxClosed')) return true;
      if (document.getElementById('onetrust-consent-sdk')) return true;
      return Boolean(window.OneTrust && typeof window.OneTrust.IsAlertBoxClosed === 'function');
    }

    consentBannerVisible() {
      const banner = document.getElementById('onetrust-banner-sdk');
      if (!banner) return false;
      const style = window.getComputedStyle(banner);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      const rect = banner.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    }

    showAfterConsent(show, skip) {
      if (!this.oneTrustOnPage()) { show(); return; }
      if (readCookie('OptanonAlertBoxClosed') && !this.consentBannerVisible()) { show(); return; }

      const startedAt = Date.now();
      const previousWrapper = window.OptanonWrapper;
      let done = false;
      let observer = null;
      let timer = null;
      let frame = null;
      let settleTimer = null;
      let clearSince = null;

      const finish = (doShow) => {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        if (timer) window.clearInterval(timer);
        if (settleTimer) window.clearTimeout(settleTimer);
        if (frame) window.cancelAnimationFrame(frame);
        window.removeEventListener('OneTrustGroupsUpdated', check);
        window.removeEventListener('consent.onetrust', check);
        if (window.OptanonWrapper === chainedWrapper) window.OptanonWrapper = previousWrapper;
        if (doShow) show();
        else if (skip) skip();
      };

      const check = () => {
        if (done) return;
        const now = Date.now();
        const elapsed = now - startedAt;
        if (this.consentBannerVisible()) {
          clearSince = null;
          if (elapsed > CONSENT_WAIT_MAX_MS) finish(false); // banner ancora aperto: niente suggerimento in questa pagina
          return;
        }
        if (readCookie('OptanonAlertBoxClosed')) { finish(true); return; } // banner chiuso dal visitatore
        if (this.oneTrustReady() || elapsed > NO_BANNER_GRACE_MS) {
          if (clearSince === null) clearSince = now;
          if (now - clearSince >= CONSENT_SETTLE_MS) { finish(true); return; }
          if (!settleTimer) settleTimer = window.setTimeout(() => { settleTimer = null; check(); }, CONSENT_SETTLE_MS);
        }
      };

      const scheduleCheck = () => {
        if (done || frame) return;
        frame = window.requestAnimationFrame(() => { frame = null; check(); });
      };

      const chainedWrapper = function () {
        if (typeof previousWrapper === 'function') {
          try { previousWrapper.apply(this, arguments); } catch (e) { /* callback del sito: non e' compito nostro */ }
        }
        scheduleCheck();
      };

      if (window.MutationObserver) {
        observer = new MutationObserver(scheduleCheck);
        observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
      }
      window.addEventListener('OneTrustGroupsUpdated', check);
      window.addEventListener('consent.onetrust', check);
      window.OptanonWrapper = chainedWrapper;
      timer = window.setInterval(check, CONSENT_POLL_MS);
      check();
    }
  }

  if (!window.customElements.get('market-suggest-bar')) {
    window.customElements.define('market-suggest-bar', MarketSuggestBar);
  }
  if (!window.customElements.get('banner-redirect')) {
    window.customElements.define('banner-redirect', BannerRedirect);
  }
})();
